var map = {
	"./i18n.json": 712,
	"./i18n_da.json": 9851,
	"./i18n_de.json": 6786,
	"./i18n_en-GB.json": 6195,
	"./i18n_en.json": 4837,
	"./i18n_es.json": 6022,
	"./i18n_fr.json": 6584,
	"./i18n_nl.json": 5724,
	"./i18n_sv.json": 4912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8973;